import { c as _c } from "react/compiler-runtime";
import { Autorenew } from "../../icons";
import { Button } from "../Button";
export function RetryButton(t0) {
  const $ = _c(12);
  let children;
  let className;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      size: t2,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const variant = t1 === undefined ? "secondary" : t1;
  const size = t2 === undefined ? "sm" : t2;
  const t3 = children ?? "Try again";
  let t4;
  if ($[6] !== className || $[7] !== rest || $[8] !== size || $[9] !== t3 || $[10] !== variant) {
    t4 = <Button className={className} icon={Autorenew} size={size} variant={variant} {...rest}>{t3}</Button>;
    $[6] = className;
    $[7] = rest;
    $[8] = size;
    $[9] = t3;
    $[10] = variant;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}